import { create } from 'zustand';

type UiStore = {
  notification: string;
  setNotification: (notification: string) => void;
  resetNotification: () => void;
};

const useUiStore = create<UiStore>((set) => ({
  notification: '',
  setNotification: (notification) => set({ notification }),
  resetNotification: () => set({ notification: '' }),
}));

export { useUiStore };
